<header class="row page-header">
    <div class="col-md-6">
        <h2 class="title pull-left">PROPERTY SETTINGS</h2>
    </div>
    <div class="col-md-6 comm-state">
        <sp-comm-state [successMessage]="'Property Saved Successfully'" [failedMessage]="'Property Save failed'"
                       [scrollOnStateChange]="true" [scrollItemSelector] = "'body'">
        </sp-comm-state>
        <sp-comm-state [successMessage]="'Property Image Saved Successfully'" [failedMessage]="'Property Image Save Failed'" #saveImage></sp-comm-state>

        <div class="alert alert-danger" role="alert" *ngIf="feedbackMessages.length !=0">
            <div *ngFor="let msg of feedbackMessages">
                <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                <span class="visually-hidden">Error:</span> {{ msg.details }}
            </div>
        </div>
    </div>
</header>

<main>

    <dx-tab-panel
        #propertyTabPanel
        [elementAttr]="{ class: 'sp-dx-tab-panel' }"
        [swipeEnabled]="false"
        [animationEnabled]="false"
        [selectedIndex]="selectedIndex"
        (onSelectionChanged)="onTabPanelSelectionChanged($event)"
        (onInitialized)="onTabPanelInitialized()">
        <dxi-tab-panel-item title="General">
            <div *dxTemplate>
                <sp-property-details-edit
                    *ngIf="property$ | async"
                    [property]="property$ | async"
                    [propertyTypes]="propertyTypes$ | async"
                    [userProfile]="userProfile$ | async"
                    [saveError]="savePropertyDetailsError$ | async"
                    (cancel)="onCancel()"
                    (save)="onSave($event)"
                    (saveImage)="onSaveImage($event)"
                    (removeImage)="onRemoveImage($event)"
                ></sp-property-details-edit>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item *ngIf="showFinancialsTab" title="Financials">
            <div *dxTemplate>
                <sp-property-financials></sp-property-financials>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item *ngIf="showReserveStudyTab" [title]="reserveStudyTabTitle">
            <div *dxTemplate>
                <sp-reserve-study-edit
                    *ngIf="property$ | async"
                    [property]="property$ | async"
                    [reserveStudies]="reserveStudies$ | async"
                    (add)="onAddReserveStudy($event)"
                    (update)="onUpdateReserveStudy($event)"
                    (delete)="onDeleteReserveStudy($event)"
                ></sp-reserve-study-edit>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item *ngIf="showConnectedAppsTab" title="Connected Apps">
            <div *dxTemplate>
                <sp-connected-apps></sp-connected-apps>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item *ngIf="showActivityTab" title="Activity">
            <div *dxTemplate>
                <sp-activity-report></sp-activity-report>
            </div>
        </dxi-tab-panel-item>
    </dx-tab-panel>
</main>
